module.exports = __webpack_public_path__ + "static/mobileblueprint-34d759ae06dc1978f704603c5d763291.png";